module.exports = __webpack_public_path__ + "static/media/John.597a81f0.jpg";